module.exports = __webpack_public_path__ + "9254953310584b54a6059fbf5b2cea54.png";